/**
 * Anzeige bei fehlerhafter Startkonfiguration. Bewusst ohne Uebersetzung und
 * ohne Sitzungskontext, da diese Komponente greift, bevor beides bereitsteht.
 */
import { Body1, Card, Subtitle1, makeStyles, tokens } from '@fluentui/react-components';
import { ErrorCircleRegular } from '@fluentui/react-icons';

const useStyles = makeStyles({
  wrapper: { display: 'flex', justifyContent: 'center', padding: tokens.spacingVerticalXXXL },
  card: { maxWidth: '640px', padding: tokens.spacingVerticalXL, display: 'flex', flexDirection: 'column', gap: tokens.spacingVerticalM },
  header: { display: 'flex', alignItems: 'center', gap: tokens.spacingHorizontalS },
  icon: { fontSize: '28px', color: tokens.colorPaletteRedForeground1 },
  code: {
    fontFamily: tokens.fontFamilyMonospace,
    backgroundColor: tokens.colorNeutralBackground3,
    padding: tokens.spacingVerticalS,
    borderRadius: tokens.borderRadiusMedium,
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
  },
});

export function ConfigurationError({ message }: { message: string }) {
  const styles = useStyles();
  return (
    <div className={styles.wrapper}>
      <Card className={styles.card} role="alert">
        <div className={styles.header}>
          <ErrorCircleRegular className={styles.icon} aria-hidden />
          <Subtitle1>Die Anwendung ist nicht korrekt konfiguriert</Subtitle1>
        </div>
        <Body1>
          Die Anmeldung konnte nicht initialisiert werden. Bitte prüfen Sie die Umgebungsvariablen der Static Web App
          (siehe <code>web/.env.example</code>) und wenden Sie sich an die IT-Administration.
        </Body1>
        <Body1 className={styles.code}>{message}</Body1>
      </Card>
    </div>
  );
}
